import { enviroment } from "../../../enviroment";

// Admin perf FE-4 (flag adminPerfHelperCacheEnabled): "soft" gates for the
// design and style lists. Today the design list shows a LoadingView until
// ALL six queries have landed - including GetManufacturers (p50 4.2 s in
// prod) and GetStyles (pageSize 0) that only feed filter dropdowns - and the
// style list waits for GetManufacturers too. With the flag on a list paints
// as soon as its primary query (+ the org lists for the design list) is
// ready; the dropdown options fill in when their data lands (same
// functionality, only the order changes). A helper-query error still ends
// in the Failed view exactly as today: isSuccess is forced false whenever
// any query errored, because the screens' dataTransition checks isSuccess
// FIRST (isSuccess + isError together would show the list with empty
// dropdowns and swallow the error). Flag off = the historical all-queries
// gate, expressed here unchanged.

export interface QueryFlags {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

export interface GateResult {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

function all(flags: QueryFlags[]): GateResult {
  return {
    isLoading: flags.some((f) => f.isLoading),
    isSuccess: flags.every((f) => f.isSuccess),
    isError: flags.some((f) => f.isError),
  };
}

export function designListGate(q: {
  designs: QueryFlags;
  organizations: QueryFlags;
  manufacturers: QueryFlags;
  options: QueryFlags;
  styles: QueryFlags;
}): GateResult {
  const everything = [
    q.designs,
    q.organizations,
    q.manufacturers,
    q.options,
    q.styles,
  ];
  if (!enviroment.adminPerfHelperCacheEnabled) return all(everything);
  return soft(all([q.designs, q.organizations]), all(everything).isError);
}

/** Primary decides loading/success; any error (helper included) = Failed. */
function soft(primary: GateResult, anyError: boolean): GateResult {
  return {
    isLoading: primary.isLoading,
    isSuccess: primary.isSuccess && !anyError,
    isError: anyError,
  };
}

export function styleListGate(q: {
  styles: QueryFlags;
  manufacturers: QueryFlags;
}): GateResult {
  const everything = [q.styles, q.manufacturers];
  if (!enviroment.adminPerfHelperCacheEnabled) return all(everything);
  return soft(all([q.styles]), all(everything).isError);
}
